




import { Vue, Component } from 'vue-property-decorator';
import { orderListTypes, focusTabName } from '@/const/order';
import ContentBottom from '@/components/shipping/order/ContentBottom.vue';

@Component({
  components: {
    ContentBottom,
  },
})
export default class OrderPreOrder extends Vue {
  private orderListTypes = orderListTypes.HOLD_BY_RESERVATION;
  private orderSearchTypes = focusTabName.ORDER_TAB;
}
